export const ANIMATION_DURATION = 700;

export const PADDING_ADD_MORE_BUTTON = 16;
